module.exports = __webpack_public_path__ + "static/img/1035_big.2ada13e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1035_big.png
// module id = Nw/r
// module chunks = 1